module.exports = __webpack_public_path__ + "assets/images/43b53f797faaf771b1d91bc5e6fcad77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icons/stack-overflow.svg
// module id = 729
// module chunks = 0